module.exports = __webpack_public_path__ + "img/5.d6ef97f3.png";